import { User } from "../models"
import { Permission, PermissionAttributes, Role } from "./permissions.types"
const PERMISSIONS: Permission = {
    admin: [],
    greezon_partner: [
        'dashboard:view',
        'chargings:list',
        'locations:list',
        'chargers:list',
        'chargers:detail'
    ],
    third_party_partner: [
        'dashboard:view',
        'chargings:list',
        'locations:list',
        'chargers:list',
        'chargers:detail',
        'plans:list',
        'locations:edit'
    ]
}

const checkPermission = (user: User, permission: PermissionAttributes) => user.is_admin || PERMISSIONS[user.role as Role].includes(permission)
export default checkPermission
